// extracted by mini-css-extract-plugin
var _1 = "d4XiN";
var _2 = "sko8C";
var _3 = "Pec3J";
export { _1 as "supportCardHeader", _2 as "supportItem", _3 as "supportList" }
